import styled, {css} from 'styled-components';
import {DatePickerContainerStyleProps} from './DatePicker.types';

const Container = styled.div<DatePickerContainerStyleProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	max-width: 336px;
	padding: 16px;
	background: ${({theme}) => theme.colors.brand.primary.white};

	opacity: 0;
	visibility: hidden;

	${({theme}) => css`
		${theme.breakpoints.up('sm')} {
			max-width: 432px;
			padding: 16px 16px 16px 24px;
		}
	`}

	${({theme}) => css`
		${theme.breakpoints.down(370)} {
			padding: 12px;
		}
	`}

	${({visible}) =>
		visible &&
		css`
			opacity: 1;
			visibility: visible;
		`}

	${({theme}) => theme.breakpoints.up('lg')} {
		width: initial;
	}
`;

const DatePickerWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
	width: 100%;

	${({theme}) => css`
		background: ${theme.colors.brand.primary.white};

		${theme.breakpoints.up('lg')} {
			display: inline-block;
		}
	`}
`;

const DatePickerContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;

	${({theme}) => css`
		${theme.breakpoints.up('lg')} {
			display: inline-block;
			padding: 0 ${theme.spacing('3x')};
			position: relative;
		}
	`}
`;

const DatePickerContent = styled.div`
	display: flex;
	align-items: flex-start;
	width: 100%;
	${({theme}) => css`
		gap: 8px;
		padding-bottom: ${theme.spacing('5x')};
	`}
`;

const Divider = styled.div`
	width: 1px;
	align-self: stretch;
	${({theme}) => css`
		margin: ${theme.spacing('10x')} 0 ${theme.spacing('3x')} 0;
		background-color: ${theme.colors.gray['40Percent']};
	`}
`;

export {Container, DatePickerWrapper, DatePickerContainer, DatePickerContent, Divider};
